<template>
  <div class="kt-table-container">
    <!-- 表格工具栏 - 放在表格上方 -->
    <div class="table-toolbar">
      <div class="toolbar-left">
        <el-button-group class="tool-group">
          <!--刷新-->
          <el-tooltip :content="$t('action.refresh')" placement="bottom">
            <el-button icon="fa fa-refresh" :size="size" @click="findPage" title="刷新">
              <span class="btn-text">刷新</span>
            </el-button>
          </el-tooltip>
          <!--列显示-->
          <el-tooltip :content="$t('action.columnList')" placement="bottom">
            <el-button icon="fa fa-th-list" :size="size" @click="displayFilterColumnsDialog" title="列设置">
              <span class="btn-text">列设置</span>
            </el-button>
          </el-tooltip>
          <!--导出Excel-->
          <el-tooltip :content="$t('action.exportExcel')" placement="bottom">
            <el-button icon="fa fa-file-excel-o" :size="size" @click="export2Excel" title="导出Excel">
              <span class="btn-text">导出</span>
            </el-button>
          </el-tooltip>
          <!--签名-->
          <el-tooltip :content="$t('action.signature')" placement="bottom">
            <el-button icon="fa fa-edit" :size="size" @click="signature" title="签名">
              <span class="btn-text">签名</span>
            </el-button>
          </el-tooltip>
        </el-button-group>
      </div>
      <div class="toolbar-right">
        <span class="table-info" v-if="data.totalSize">
          共 <strong>{{ data.totalSize }}</strong> 条记录
        </span>
      </div>
    </div>

    <!--表格栏-->
    <el-table ref="table" :data="data.content" :highlight-current-row="highlightCurrentRow" @selection-change="selectionChange"
          @current-change="handleCurrentChange" v-loading="loading" :element-loading-text="$t('action.loading')" :border="border" :stripe="stripe"
          :show-overflow-tooltip="showOverflowTooltip" :max-height="maxHeight" :height="height" :size="size" :align="align" style="width:100%;" >
      <el-table-column type="selection" width="40px" v-if="showBatchDelete & showOperation"></el-table-column>
      <el-table-column v-for="column in columns" header-align="center" align="center"
        :prop="column.prop" :label="$t(column.label)" :width="column.width" :min-width="column.minWidth" v-if="column.display==null?true:column.display"
        :fixed="column.fixed" :key="column.prop" :type="column.type" :formatter="column.formatter"
        :sortable="column.sortable==null?true:column.sortable">
      </el-table-column>
      <el-table-column :label="$t('action.operation')" width="60" v-if="showOperation" header-align="center" fixed="right" align="center">
        <template slot-scope="scope">
          <el-dropdown size="mini" trigger="click" @command="(cmd) => handleDropdownCommand(cmd, scope.$index, scope.row)">
            <el-button size="mini" type="primary">
              <i class="el-icon-menu"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="op1" v-if="displayOperation1Button">
                <i class="fa fa-list-alt"></i> {{buttonOperation1}}
              </el-dropdown-item>
              <el-dropdown-item command="op2" v-if="displayOperation2Button">
                <i class="fa fa-check-square-o"></i> {{buttonOperation2}}
              </el-dropdown-item>
              <el-dropdown-item command="op3" v-if="displayOperation3Button">
                <i class="fa fa-gear"></i> {{buttonOperation3}}
              </el-dropdown-item>
              <el-dropdown-item command="op4" v-if="displayOperation4Button">
                <i class="fa fa-star-o"></i> {{buttonOperation4}}
              </el-dropdown-item>
              <el-dropdown-item command="op5" v-if="displayOperation5Button">
                <i class="fa fa-bookmark-o"></i> {{buttonOperation5}}
              </el-dropdown-item>
              <el-dropdown-item command="edit" v-if="displayButtonEdit" :class="{'dropdown-divider': displayOperation1Button || displayOperation2Button || displayOperation3Button || displayOperation4Button || displayOperation5Button}">
                <i class="fa fa-edit"></i> {{buttonEdit}}
              </el-dropdown-item>
              <el-dropdown-item command="delete" v-if="displayButtonDelete">
                <i class="fa fa-trash" style="color:#f56c6c;"></i> {{buttonDelete}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--分页栏-->
    <div class="pagination-bar">
      <div class="pagination-left">
        <div class="batch-actions">
          <kt-button :label="batchDelete" :perms="permsDelete" :size="size" type="danger" @click="handleBatchDelete()"
            :disabled="this.selections.length===0" v-if="showBatchDelete & showOperation"/>
          <kt-button :label="batchButtonOperation1" :perms="permsDelete" :size="size" type="danger" @click="handleBatchOperation1()"
                     :disabled="this.selections.length===0" v-if="showBatchButton1"/>
          <kt-button :label="batchButtonOperation2" :perms="permsDelete" :size="size" type="danger" @click="handleBatchOperation2()"
                     :disabled="this.selections.length===0" v-if="showBatchButton2"/>
          <kt-button :label="batchButtonOperation3" :perms="permsDelete" :size="size" type="danger" @click="handleBatchOperation3()"
                     :disabled="this.selections.length===0" v-if="showBatchButton3"/>
          <kt-button :label="batchButtonOperation4" :perms="permsDelete" :size="size" type="danger" @click="handleBatchOperation4()"
                     :disabled="this.selections.length===0" v-if="showBatchButton4"/>
          <kt-button :label="batchButtonOperation5" :perms="permsDelete" :size="size" type="danger" @click="handleBatchOperation5()"
                     :disabled="this.selections.length===0" v-if="showBatchButton5"/>
          <kt-button :label="batchButtonOperation6" :perms="permsDelete" :size="size" type="danger" @click="handleBatchOperation6()"
                     :disabled="this.selections.length===0" v-if="showBatchButton6"/>
        </div>
      </div>
      <div class="pagination-right">
        <el-pagination
          :current-page="pageRequest.pageNum"
          :page-size="pageRequest.pageSize"
          :total="data.totalSize"
          layout="total, prev, pager, next, jumper"
          @current-change="refreshPageRequest">
        </el-pagination>
      </div>
    </div>

    <!--表格显示列界面-->
    <table-column-filter-dialog ref="tableColumnFilterDialog" :columns="columns"
                                @handleFilterColumns="handleFilterColumns">
    </table-column-filter-dialog>
  </div>
</template>

<script>
import KtButton from "@/views/Core/KtButton"
import TableColumnFilterDialog from "@/views/Core/TableColumnFilterDialog"
export default {
  name: 'KtTable',
  components:{
    KtButton,
    TableColumnFilterDialog
	},
  props: {
    columns: Array, // 表格列配置
    data: Object, // 表格分页数据
    permsEdit: String,  // 编辑权限标识
    permsDelete: String,  // 删除权限标识
    permsView: String, // 显示明细权限标识
    displayButtonEdit: {  // 是否显示编辑按钮
      type: Boolean,
      default: true
    },
    displayButtonDelete: {  // 是否显示删除按钮
      type: Boolean,
      default: true
    },
    displayOperation1Button: {  // 是否显示明细按钮
      type: Boolean,
      default: false
    },
    displayOperation2Button: {  // 是否显示操作按钮2
      type: Boolean,
      default: false
    },
    displayOperation3Button: {  // 是否显示操作按钮3
      type: Boolean,
      default: false
    },
    displayOperation4Button: {  // 是否显示操作按钮4
      type: Boolean,
      default: false
    },
    displayOperation5Button: {  // 是否显示操作按钮5
      type: Boolean,
      default: false
    },
    showBatchDelete: {  // 是否显示操作组件
      type: Boolean,
      default: true
    },
    showBatchButton1: {  // 是否显示批量操作按钮1
      type: Boolean,
      default: false
    },
    showBatchButton2: {  // 是否显示批量操作按钮2
      type: Boolean,
      default: false
    },
    showBatchButton3: {  // 是否显示批量操作按钮3
      type: Boolean,
      default: false
    },
    showBatchButton4: {  // 是否显示批量操作按钮4
      type: Boolean,
      default: false
    },
    showBatchButton5: {  // 是否显示批量操作按钮5
      type: Boolean,
      default: false
    },
    showBatchButton6: {  // 是否显示批量操作按钮6
      type: Boolean,
      default: false
    },
    size: { // 尺寸样式
      type: String,
      default: 'mini'
    },
    align: {  // 文本对齐方式
      type: String,
      default: 'left'
    },
    maxHeight: {  // 表格最大高度
      type: Number,
      default: 440
    },
    height: {  // 表格最大高度
      type: Number,
      default: 440
    },
    showOperation: {  // 是否显示操作组件
      type: Boolean,
      default: true
    },
    border: {  // 是否显示边框
      type: Boolean,
      default: false
    },
    stripe: {  // 是否显示斑马线
      type: Boolean,
      default: true
    },
    highlightCurrentRow: {  // // 是否高亮当前行
      type: Boolean,
      default: true
    },
    showOverflowTooltip: {  // 是否单行显示
      type: Boolean,
      default: true
    },
    pageSize: {
      type: Number,
      default: null  // 不传则用 KtTable 自己的默认值；传了则以父组件为准
    },
    pageNum: {
      type: Number,
      default: null
    },
    buttonOperation1: '',//按钮1显示文本
    buttonOperation2: '',//按钮2显示文本
    buttonOperation3: '',//按钮3显示文本
    buttonOperation4: '',//按钮4显示文本
    buttonOperation5: '',//按钮5显示文本
    buttonEdit: '', //编辑按钮显示文本
    buttonDelete: '', //删除按钮显示文本
    batchButtonOperation1: '',//批量按钮1显示文本
    batchButtonOperation2: '',//批量按钮2显示文本
    batchButtonOperation3: '',//批量按钮3显示文本
    batchButtonOperation4: '',//批量按钮4显示文本
    batchButtonOperation5: '',//批量按钮5显示文本
    batchButtonOperation6: '',//批量按钮6显示文本
    batchDelete: '',//批量删除按钮显示文本
  },
  data() {
    return {
      widthOfOperation:'auto',
      filterColumns: [],
      // 分页信息
			pageRequest: {
				pageNum: 1,
        pageSize: 10
      },
      loading: false,  // 加载标识
      selections: []  // 列表选中列
    }
  },
  created() {
    // 父组件显式传了 pageSize/pageNum 时，以父组件为准，覆盖默认值
    if (this.pageSize !== null) {
      this.pageRequest.pageSize = this.pageSize
    }
    if (this.pageNum !== null) {
      this.pageRequest.pageNum = this.pageNum
    }
  },
  computed: {
    // 判断是否有更多操作需要显示在下拉菜单中
    hasMoreOperations: function() {
      return this.displayOperation4Button || this.displayOperation5Button || this.displayButtonEdit || this.displayButtonDelete
    }
  },
  methods: {
    // 处理表格列过滤显示
    displayFilterColumnsDialog: function () {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true)
    },
    // 处理表格列过滤显示
    handleFilterColumns: function (data) {
      this.columns = data.filterColumns
      this.$refs.tableColumnFilterDialog.setDialogVisible(false)
    },
    // 处理表格列过滤显示
    initColumns: function () {
      let length = this.columns.length
      for(let i=0; i<length; i++) {
        this.columns[i].label = this.$t(this.columns[i].label)
      }
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));

      let count = 0
      if (this.displayButtonDelete) {
        count=count+1
      }
      if (this.displayButtonEdit) {
        count=count+1
      }
      if (this.displayOperation1Button) {
        count=count+1
      }
      if (this.displayOperation2Button) {
        count=count+1
      }

      if (count===1) {
        this.widthOfOperation='105px'
      } else if (count>1) {
        this.widthOfOperation='195px'
      } else {
        this.widthOfOperation='auto'
      }
    },
    signature() {
      this.$router.push({
        path: "/Core/Signature",
        query: {
          date:new Date().getTime()
        }
      })
    },
    export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel");
        // const fieldName = ["索引", "用户名", "密码"];
        // const filterVal = ["index", "username", "password"];
        // const data = this.tableData.map(v => filterVal.map(j => v[j]));
        // export_json_to_excel(fieldName, data, "用户列表");

        const fieldName = this.$refs.table.$children.reduce((acc, cur) => {
          if (cur.label && cur.label != '操作') {
            acc.push(cur.label)
            return acc
          }
          return acc
        }, [])

        const filterVal = this.$refs.table.$children.reduce((acc, cur) => {
          if (cur.prop) {
            acc.push(cur.prop)
            return acc
          }
          return acc
        }, [])

        if (!this.data.content){
          this.$message({message: this.$t("common.message.nullData")+'', type: 'error'})
        } else {
          const data = this.data.content.map(v => filterVal.map(j => v[j]));
          if (data.length==0){
            this.$message({message: this.$t("common.message.nullData")+'', type: 'error'})
          } else {
            data.unshift(fieldName);

            const fileName = this.$router.currentRoute.name + this.getCurrentTime()
            export_json_to_excel(fieldName, data, fileName);
          }
        }
      });
    },
    getCurrentTime() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth()+1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds()<10 ? '0'+new Date().getSeconds() : new Date().getSeconds();
      _this.gettime = yy+'-'+mm+'-'+dd;

      return _this.gettime
    },
    // 分页查询
    findPage: function () {
        this.loading = false
        let callback = res => {
          this.loading = false
        }
      //this.$emit调用父组件的方法，this.$refs调用子组件的方法
      this.$emit('findPage', {pageRequest:this.pageRequest, callback:callback})
    },
    // 选择切换
    selectionChange: function (selections) {
      this.selections = selections
      this.$emit('selectionChange', {selections:selections})
    },
    // 选择切换
    handleCurrentChange: function (val) {
      this.$emit('handleCurrentChange', {val:val})
    },
    // 换页刷新
		refreshPageRequest: function (pageNum) {
      this.pageRequest.pageNum = pageNum
      //不执行findPage表格就不会显示数据
      this.findPage()
    },
    // 编辑
		handleEdit: function (index, row) {
      this.$emit('handleEdit', {index:index, row:row})
		},
    // 删除（传完整 row，支持 whId 等字段）
		handleDelete: function (index, row) {
			this.deleteWithRow(row)
		},
    // 操作1
    handleOperation1: function (index, row) {
      this.$emit('handleOperation1', {index:index, row:row})
    },
    // 操作2
    handleOperation2: function (index, row) {
      this.$emit('handleOperation2', {index:index, row:row})
    },
    // 操作3
    handleOperation3: function (index, row) {
      this.$emit('handleOperation3', {index:index, row:row})
    },
    // 操作4
    handleOperation4: function (index, row) {
      this.$emit('handleOperation4', {index:index, row:row})
    },
    // 操作5
    handleOperation5: function (index, row) {
      this.$emit('handleOperation5', {index:index, row:row})
    },
    // 下拉菜单命令处理
    handleDropdownCommand: function (command, index, row) {
      if (command === 'op1') {
        this.handleOperation1(index, row)
      } else if (command === 'op2') {
        this.handleOperation2(index, row)
      } else if (command === 'op3') {
        this.handleOperation3(index, row)
      } else if (command === 'op4') {
        this.handleOperation4(index, row)
      } else if (command === 'op5') {
        this.handleOperation5(index, row)
      } else if (command === 'edit') {
        this.handleEdit(index, row)
      } else if (command === 'delete') {
        this.handleDelete(index, row)
      }
    },
		// 批量删除
		handleBatchDelete: function () {
			let ids = this.selections.map(item => item.id).toString()
			this.delete(ids)
		},
    // 批量操作1
    handleBatchOperation1: function () {
      // let ids = this.selections.map(item => item.id).toString()
      // this.BatchOperation1(ids)
      this.$emit('handleBatchOperation1', {params:this.selections})
    },
    // 批量操作2
    handleBatchOperation2: function () {
      this.$emit('handleBatchOperation2', {params:this.selections})
    },
    // 批量操作3
    handleBatchOperation3: function () {
      this.$emit('handleBatchOperation3', {params:this.selections})
    },
    // 批量操作4
    handleBatchOperation4: function () {
      this.$emit('handleBatchOperation4', {params:this.selections});
    },

    // 批量操作5
    handleBatchOperation5: function () {
      this.$emit('handleBatchOperation5', {params:this.selections});
    },
    // 批量操作6
    handleBatchOperation6: function () {
      this.$emit('handleBatchOperation6', {params:this.selections});
    },
		// 批量操作1
    BatchOperation1: function (ids) {
			this.$confirm(this.$t("common.message.confirmSelected")+'', this.$t("common.message.prompt")+'', {
				type: 'warning'
			}).then(() => {
				let params = []
				let idArray = (ids+'').split(',')
				for(var i=0; i<idArray.length; i++) {
					params.push({'id':idArray[i]})
        }
        // this.loading = true
        let callback = res => {
          if(res.code == 200) {
            this.$message({message: this.$t("common.message.success")+'', type: 'success'})
            this.findPage()
          } else {
            this.$message({message: this.$t("common.message.fail") + this.$t(res.msg), type: 'error'})
          }
          // this.loading = false
        }
        this.$emit('handleBatchOperation1', {params:params, callback:callback})
			}).catch(() => {
			})
		},
    // 单行删除（带完整 row 数据）
    deleteWithRow: function (row) {
      this.$confirm(this.$t("common.message.confirmSelected")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+'',
        type: 'warning'
      }).then(() => {
        let params = [{...row}]  // 保留 row 所有字段（含 whId）
        let callback = res => {
          if(res.code == 200) {
            if(res.data == 0) {
              this.$message({message: this.$t("common.message.fail") + this.$t("common.message.notAllowDelete"), type: 'error'})
            } else {
              this.$message({message: this.$t("common.message.success")+'', type: 'success'})
              this.findPage()
            }
          } else {
            this.$message({message: this.$t("common.message.fail") + this.$t(res.msg), type: 'error'})
          }
        }
        this.$emit('handleDelete', {params:params, callback:callback})
      }).catch(() => {
      })
    },

    // 保留旧 delete（批量删除用，仅 id 列表）
    delete: function (ids) {
      this.$confirm(this.$t("common.message.confirmSelected")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+'',
        type: 'warning'
      }).then(() => {
        let params = []
        let idArray = (ids+'').split(',')
        for(var i=0; i<idArray.length; i++) {
          params.push({'id':idArray[i]})
        }
        // this.loading = true
        let callback = res => {
          if(res.code == 200) {
            if(res.data == 0) {
              this.$message({message: this.$t("common.message.fail") + this.$t("common.message.notAllowDelete"), type: 'error'})
            } else {
              this.$message({message: this.$t("common.message.success")+'', type: 'success'})
              this.findPage()
            }
          } else {
            this.$message({message: this.$t("common.message.fail") + this.$t(res.msg), type: 'error'})
          }
          // this.loading = false
        }
        this.$emit('handleDelete', {params:params, callback:callback})
      }).catch(() => {
      })
    }
  },
  mounted() {
    //第一次打开页面，不渲染表格数据
    // this.refreshPageRequest(1)
    this.initColumns()
  }
}
</script>

<style scoped>
/* 表格容器 */
.kt-table-container {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* ========== 表格上方工具栏 ========== */
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: linear-gradient(180deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-bottom: none;
  border-radius: 6px 6px 0 0;
}

.toolbar-left {
  display: flex;
  align-items: center;
}

.toolbar-right {
  display: flex;
  align-items: center;
}

/* 工具按钮组 */
.tool-group {
  display: flex;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}

.tool-group .el-button {
  border: none;
  border-radius: 0;
  border-right: 1px solid #e4e7ed;
  background: #fff;
  color: #606266;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
}

.tool-group .el-button:first-child {
  border-radius: 4px 0 0 4px;
}

.tool-group .el-button:last-child {
  border-radius: 0 4px 4px 0;
  border-right: none;
}

.tool-group .el-button:hover {
  background: #ecf5ff;
  color: #409eff;
}

.tool-group .el-button:active {
  background: #d9ecff;
}

.tool-group .el-button i {
  font-size: 14px;
}

/* 按钮文字 */
.tool-group .btn-text {
  font-size: 13px;
  font-weight: 500;
}

/* 表格信息 */
.table-info {
  font-size: 13px;
  color: #909399;
}

.table-info strong {
  color: #409eff;
  font-weight: 600;
}

/* ========== 表格主体 ========== */
.el-table {
  font-size: 13px;
  border-radius: 0;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
}

/* 表头样式 */
.el-table__header th {
  background: linear-gradient(180deg, #f5f7fa 0%, #ebeef5 100%) !important;
  color: #303133;
  font-weight: 600;
  font-size: 13px;
  border-bottom: 2px solid #dcdfe6 !important;
}

/* 表头文字 */
.el-table__header .cell {
  color: #303133;
  font-weight: 600;
}

/* 斑马线优化 */
.el-table__body tr:nth-child(even) {
  background-color: #fafafa;
}

.el-table__body tr:hover > td {
  background-color: #ecf5ff !important;
}

/* 表格单元格 */
.el-table__body td {
  border-bottom: 1px solid #ebeef5 !important;
  padding: 10px 0;
}

/* ========== 操作列下拉按钮 ========== */
.el-table__body-cell .el-dropdown .el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
  padding: 5px 8px;
  border-radius: 4px;
}

.el-table__body-cell .el-dropdown .el-button--primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

/* ========== 下拉菜单 ========== */
.el-dropdown-menu__item {
  padding: 8px 16px;
  font-size: 13px;
}

.el-dropdown-menu__item i {
  margin-right: 8px;
  width: 14px;
}

.el-dropdown-menu {
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 4px 0;
}

.dropdown-divider {
  border-top: 1px solid #ebeef5;
  margin: 4px 0;
}

/* ========== 分页栏 ========== */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8f9fb 100%);
  border: 1px solid #e4e7ed;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.pagination-left {
  display: flex;
  align-items: center;
}

/* 批量操作按钮 */
.batch-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pagination-right {
  display: flex;
  align-items: center;
}

/* 分页器 */
.el-pagination {
  font-weight: 500;
}

.el-pagination button,
.el-pagination .el-pager li {
  border-radius: 4px;
  margin: 0 2px;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
}

.el-pagination .el-pager li:hover {
  color: #409eff;
}

.el-pagination .el-pager li.active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

/* ========== 加载样式 ========== */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.9);
}

.el-loading-spinner .el-loading-text {
  color: #409eff;
}

.el-loading-spinner .path {
  stroke: #409eff;
}

/* ========== 其他 ========== */
.el-table__body tr.current-row > td,
.el-table__body tr:hover.current-row > td {
  background-color: #e6f0ff !important;
}

.el-table .el-table__fixed,
.el-table .el-table__fixed-right {
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.05);
}

.el-table .el-table__fixed-right {
  box-shadow: 4px 0 8px rgba(0, 0, 0, 0.05);
}

/* ========== 响应式 ========== */
@media screen and (max-width: 768px) {
  .tool-group .btn-text {
    display: none;
  }
  .tool-group .el-button {
    padding: 8px 10px;
  }
  .table-info {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Core/KtTable.vue